module.exports = "<div class=\"reservation-report-area-container\" *ngIf=\"merchant\">\n  <app-button class=\"m-r-lg\" [loading]=\"isLoading\" (clicked)=\"onDownloadReservationReport()\">Generate report!</app-button>\n\n  <a [href]=\"downloadLink\" *ngIf=\"downloadLink\">\n    Download Excel\n  </a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/merchant-tools/reservation-report/reservation-report.component.html
// module id = 1266
// module chunks = 0